module.exports = __webpack_public_path__ + "img/80 x 70.0d62ab21.jpg";